<section fxLayout="column" fxFlex="1 1 auto">
    <nav mat-tab-nav-bar>
        <span mat-tab-link *ngFor="let link of inverterTabLink"
            [ngClass]="{'set-blue-color sen-no-pointer' :  (link.label != inverterTabLink[1].label && link.label != inverterTabLink[0].label), 'sen-pointer': (link.label == inverterTabLink[1].label || link.label == inverterTabLink[0].label)}" [routerLink]="[link.link]" routerLinkActive
            #rla="routerLinkActive" [active]="activeLink == link.link">
            {{link.label}} </span>
    </nav>
    <router-outlet></router-outlet>
</section>